export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_REQUEST_PROVIDER = 'AUTH_REQUEST_PROVIDER';

export const USER_REGISTER = 'USER_REGISTER';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';
export const SET_PROFILE_DATA = 'SET_PROFILE_DATA';
export const EMAIL_VERIFICATION = 'USER_EMAIL_VERIFICATION';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';

export const SET_NOTIFICATION = 'SET_MESSAGE';

export const COMMUNITY_REQUEST = 'COMMUNITY_REQUEST';
export const COMMUNITY_SUCCESS = 'COMMUNITY_SUCCESS';
export const COMMUNITY_ERROR = 'COMMUNITY_ERROR';
export const SET_COMMUNITIES = 'SET_COMMUNITIES';
export const COMMUNITY_CREATE = 'COMMUNITY_CREATE';
export const COMMUNITY_TYPE_REQUEST = 'COMMUNITY_TYPE_REQUEST';
export const COMMUNITY_DETAIL_REQUEST = 'COMMUNITY_DETAIL_REQUEST';
export const COMMUNITY_EDIT = 'COMMUNITY_EDIT';
export const UPDATE_PICTURE = 'UPDATE_PICTURE';
export const SET_COMMUNITY_DETAIL = 'COMMUNITY_COMMUNITY_DETAIL';
export const SET_COMMUNITY_TYPES = 'SET_COMMUNITY_TYPES';
export const TAG_REQUEST = 'TAG_REQUEST';
export const SET_TAGS = 'SET_TAGS';

export const EVENT_REQUEST = 'EVENT_REQUEST';
export const EVENT_SUCCESS = 'EVENT_SUCCESS';
export const EVENT_ERROR = 'EVENT_ERROR';
export const SET_EVENTS = 'SET_EVENTS';
export const EVENT_CREATE = 'EVENT_CREATE';
export const EVENT_DETAIL = 'EVENT_DETAIL';
export const SET_EVENT_DETAIL = 'SET_EVENT_DETAIL';
export const EVENT_EDIT = 'EVENT_EDIT';
export const UPDATE_EVENT_PICTURE = 'UPDATE_EVENT_PICTURE';
export const UPDATE_EVENT_TAGS = 'UPDATE_EVENT_TAGS';
export const EVENT_DELETE = 'EVENT_DELETE';
export const POSTAL_CODE_REQUEST = 'POSTAL_CODE_REQUEST';
export const SET_POSTAL_CODE = 'SET_POSTAL_CODE';

export const CONTENT_REQUEST = 'CONTENT_REQUEST';
export const CONTENT_SUCCESS = 'CONTENT_SUCCESS';
export const CONTENT_ERROR = 'CONTENT_ERROR';

export const PRIVACY_REQUEST = 'PRIVACY_REQUEST';
export const SET_PRIVACY_DATA = 'SET_PRIVACY_DATA';

export const EULA_REQUEST = 'EULA_REQUEST';
export const SET_EULA_DATA = 'SET_EULA_DATA';

export const FEATURE_REQUEST = 'FEATURE_REQUEST';
export const SET_FEATURE_REQUEST = 'SET_FEATURE_REQUEST';

export const API_URL = process.env.VUE_APP_COLORSJP_API_URL;
